import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/My',
    name: 'My',
    component: () => import('../views/My.vue')
  },
  {
    path: '/Share',
    name: 'Share',
    component: () => import('../views/Share.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router

      
